export const isLocal =
  process.env.NODE_ENV === 'development'
    ? 'https://dev.missionaustralia.com.au/'
    : '';
